import axios from "@/utils/request";
//  - 列表
export const pageList=(data:any)=>{
    return axios({
        path:"/onlineMedical/medicalComp/subUser/page",
        data
    })
}

//  - 列表
export const fetList=()=>{
    return axios({
        path:"/onlineMedical/medicalComp/subUser/list"
    })
}

//  - 添加
export const save = (data:any)=>{
    return axios({
        path:"/onlineMedical/medicalComp/subUser/save",
        method:"POST",
        data
    })
}

//  - 修改
export const update = (data:any)=>{
    return axios({
        path:"/onlineMedical/medicalComp/subUser/update",
        method:"POST",
        data
    })
}
